import { usePersonInfo } from '@/data/Content/PersonInfo';
import { useSettings } from '@/data/Settings';
import { getExternalId } from '@/data/utils/externalId';
import { PinterestClientPayload } from '@/pages/api/tracking/pinterest/pinterestAPIUtils';
import { usePinterestClickIdentifiers } from 'presentation/events/hooks/useClickIdentifiers';
import { useTrackingStoreLocation } from 'presentation/events/hooks/useTrackingStoreLocation';
import { triggerPinterestCAPIEvent } from 'presentation/events/services/pinterestService';
import { safeEncodeUrl } from 'presentation/events/utils/ga4Utils';
import { useCallback } from 'react';

interface PinterestEventParams {
	searchTerm: string;
	eventId: string;
	storeId: string;
}

export const useTrackSearchSubmitPinterest = () => {
	const { settings } = useSettings();
	const { userData } = settings;
	const { personInfo } = usePersonInfo();
	const { epik } = usePinterestClickIdentifiers();
	const storeLocation = useTrackingStoreLocation();

	const sendPinterestEvent = useCallback(
		({ searchTerm, eventId, storeId }: PinterestEventParams) => {
			if (userData?.ENABLE_PINTEREST_CALL !== 'true') return;

			const pinterestPayload: PinterestClientPayload = {
				event_name: 'search',
				epik,
				test: userData?.ENABLE_PINTEREST_TEST === 'true',
				event_id: eventId,
				event_source_url: safeEncodeUrl(window.location.href),
				storeId,
				custom_data: {
					email: personInfo?.email1,
					phone: personInfo?.phone1,
					firstName: personInfo?.firstName,
					lastName: personInfo?.lastName,
					city: storeLocation?.city,
					state: storeLocation?.state,
					externalId: getExternalId(),
					search_string: searchTerm,
					zip: storeLocation?.zipCode,
				},
			};

			triggerPinterestCAPIEvent(pinterestPayload);
		},
		[
			epik,
			storeLocation,
			personInfo?.email1,
			personInfo?.firstName,
			personInfo?.lastName,
			personInfo?.phone1,
			userData?.ENABLE_PINTEREST_CALL,
			userData?.ENABLE_PINTEREST_TEST,
		]
	);

	return { sendPinterestEvent };
};
